import React from 'react';
import { bool, string, func, object } from 'prop-types';
import { translate } from 'react-i18next';
import { InfoCircle } from 'wix-ui-icons-common';
import styles from './embedded-integration-content.scss';

import { Input, Checkbox, Tooltip } from 'wix-style-react';

const getErrorMessage = (trackingId, isDirty) =>
  isDirty && trackingId
    ? 'embedded-integrations.modal.input.error.invalid'
    : 'embedded-integrations.modal.input.error.empty';

const EmbeddedIntegrationContentView = ({
  t,
  trackingId,
  isValid,
  isDirty,
  isChecked,
  type,
  checkbox,
  placeholder,
  onInputChange,
  onToggleCheckbox,
}) => (
  <div
    className={styles.container}
    data-hook={`mi-${type}-embedded-integration-content`}
  >
    <div className={styles.keyInput}>
      <Input
        dataHook={`mi-${type}-embedded-integration-content-key-input`}
        autoFocus
        value={trackingId}
        placeholder={t(placeholder)}
        onChange={onInputChange}
        {...(isDirty && !isValid
          ? {
              status: 'error',
              statusMessage: t(getErrorMessage(trackingId, isDirty)),
            }
          : {})}
      />
    </div>
    <div className={styles.checkboxContainer}>
      {checkbox && (
        <div className={styles.checkbox}>
          <Checkbox checked={isChecked} onChange={onToggleCheckbox}>
            {t(checkbox.label)}
          </Checkbox>
          <Tooltip
            dataHook={`mi-${type}-embedded-integration-key-tooltip`}
            content={t(checkbox.tooltip)}
            maxWidth="280px"
          >
            <span className={styles.checkboxTooltip}>
              <InfoCircle />
            </span>
          </Tooltip>
        </div>
      )}
    </div>
  </div>
);

EmbeddedIntegrationContentView.propTypes = {
  t: func.isRequired,
  trackingId: string,
  isValid: bool.isRequired,
  isDirty: bool.isRequired,
  isChecked: bool,
  type: string.isRequired,
  checkbox: object,
  placeholder: string.isRequired,
  onInputChange: func.isRequired,
  onToggleCheckbox: func.isRequired,
};

export default translate()(EmbeddedIntegrationContentView);
